import React, { useContext } from 'react';
export const GroupContext = React.createContext(null);
export const GroupContextProvider = GroupContext.Provider;
export function useGroupContext() {
    return useContext(GroupContext);
}
